import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";

const ProviderCompanyFilter = ({
    value,
    onChange,
    disabled = false,
    showAllOption = true,
    allowClear = true,
    hideTitle = false,
    marginBottom = "20px",
    ...props
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    const [, providerCompanyOptions] = useFetch({
        fetchFn: stores.companyStore.providerCompanies.bind(null, {}),
        initialCall: true
    });

    return (
        <React.Fragment>
            {!hideTitle && <h5>Sağlayıcı Firma</h5>}
            <SelectField
                data-testid="providerCompanySelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                allowClear={allowClear}
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="providerCompanySelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {providerCompanyOptions?.map(providerCompany => (
                    <SelectField.Option
                        key={providerCompany?.value}
                        value={providerCompany?.value}
                        data-testid="providerCompanySelect_option"
                    >
                        {providerCompany?.label || "-"}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default ProviderCompanyFilter;
